<template lang="pug">
  app-modal(v-model="visible" title="完成" :width="500" :confirm-loading="loading" @ok="handleSubmit" @cancel="hide")
    app-form(:model="model" :rules="rules" ref="form" oneline :labelWidth="60")     
      a-form-model-item(label="备注" prop="remark" )
        a-textarea(v-model="model.remark" allow-clear :max-length="30" placeholder="请输入备注")
            
        
</template>

<script>
import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';
export default {
  name: 'Appraise',
  props: {
    target: Object,
  },
  data() {
    return {
      visible: false,
      loading: false,
      model: {
        remark: null,
      },
      rules: {
        remark: [{ required: true, message: '必填项' }],
      },
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
  },
  created() {},
  mounted() {},
  methods: {
    show(model, action) {
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.$refs.form.resetFields();
      this.model = {
        //
      };
    },
    async handleSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        this.loading = true;
        this.$restful(`POST:/prj/orders/completing`, {
          ...this.target,
          ...this.model,
          projectId: this.project.id,
          taskId: this.target.id,
        })
          .then(() => {
            this.$message.success('任务完成!');
            this.hide();
            this.$emit('modal-success');
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
